import schema from './schema';

export const releaseAction = {
  schema,
};
